
import {useFormFields} from "../hooks/forms/useGet";
import Loader from "./Loader";
import TextField from "./TextField";
import {useMemo} from "react";
import NetworkError from "./NetworkError";

const FormPreview = ({formId}) => {

    const {data, isError, error, isLoading, isSuccess} = useFormFields(formId)



    const userSections = useMemo(() => data?.filter(fs => !fs.isOfficial && fs.activeStatus), [data])


    if (isError && error.code === 'ERR_NETWORK') {
        return (
            <NetworkError error={error}/>
        )
    }

    return (
        <div className={'py-2  overflow-y-scroll '}>
            {(isSuccess && userSections.length > 0) &&
                <div className={'flex flex-col space-y-12 '}>
                    {userSections.map((fs, i) =>
                        <section key={i}>
                            {fs.name &&
                                <p className={'text-center py-1.5 uppercase text-gray-800 bg-gray-200 '}> {fs.name}</p>}
                            <div key={i} className={'grid grid-cols-2 gap-4'}>
                                {fs.formFields.map((ff, i) => <TextField
                                        key={i}
                                        id={ff.formFieldId}
                                        label={ff.label}
                                        type={ff.formFieldType?.fieldTypeName}
                                        required={ff.required}
                                        hidden={!ff.activeStatus}
                                        options={ff.formFieldOptions}
                                        disabled
                                    />
                                )}
                            </div>
                        </section>
                    )}
                </div>
                }
            {(isSuccess && userSections.length === 0) &&
                <p className={'text-center whitespace-normal'}> Provided sections are for official use only. Kindly contact management for
                    assistance. </p>}

            {isLoading && <Loader className={'fixed inset-0'}/>}
        </div>
    )
};

export default FormPreview;